module.exports = __webpack_public_path__ + "img/statistics-bg-3.11866325.png";